import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {FilingLinkMainModel} from '../../../../../../models/aggregates/erp/financial-filing';
import {Core2Config} from '../../shared';

@Injectable({ providedIn: 'root' })
export class FilingLinkService extends BaseApiTemplateService<FilingLinkMainModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + Core2Config.ERP_PREFIX + 'filing-links';

    constructor(theHttp: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + Core2Config.ERP_PREFIX + 'filing-links';
        this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + Core2Config.ERP_PREFIX + 'filing-links';
        this.httpClient = theHttp;
  }



}
